import { render, staticRenderFns } from "./userGrowth.vue?vue&type=template&id=19461a2e&scoped=true&"
import script from "./userGrowth.vue?vue&type=script&lang=js&"
export * from "./userGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19461a2e",
  null
  
)

export default component.exports